import React from "react"


// This component shows a shifting perspective of its content while the mouse move
class ProjectCards extends React.Component {

    constructor(props) {
        super(props);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.state = { x: 0, y: 0, rx: 0, ry: 0};
      }

    handleMouseLeave(event) {
        this.setState({
            x: event.clientX,
            y: event.clientY,
            rx: `0rad`,
            ry: `0rad `
          });
    }

    handleMouseMove(event) {
        
        const rotationDamp = 1
        event.preventDefault()

        // Trigger mouse position drive perspective shift 
        // only on large enough viewports.
        // Check also the breakpoints
        if (window.innerWidth < 768) return

        this.setState({
          x: event.clientX,
          y: event.clientY,
          rx: `${(event.clientY - (window.innerHeight / 2)) / window.innerHeight}rad`,
          ry: `${-(event.clientX - (window.innerWidth / 2)) / window.innerWidth}rad`
        });
    }

    render() {
        return (
            <div className="projectCards"
                role="grid" tabIndex={ -1 }
                onMouseLeave={ this.handleMouseLeave }
                onMouseMove={ this.handleMouseMove }
                style={{ transform: `rotateX(${this.state.rx}) rotateY(${this.state.ry})` }}
            >
                {this.props.children}
            </div>
        )
    }
};

export default ProjectCards;